import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Carla M.',
    role: 'Profesora online',
    text: 'Pasé de improvisar todas mis clases a tener todo organizado. Me ahorra horas.'
  }, {
    name: 'Lucas R.',
    role: 'Academia de idiomas',
    text: 'Mis alumnos participan mucho más. Antes se aburrían, ahora esperan la clase.'
  }, {
    name: 'Sofía G.',
    role: 'Profesora particular',
    text: 'El guión de clase me dio seguridad total. Ahora sé exactamente qué hacer.'
  }, {
    name: 'Martina V.',
    role: '28 años, Buenos Aires',
    text: 'Desde que uso este sistema, mis alumnos de nivel inicial avanzan mucho más rápido. Las plantillas de Notion son un viaje de ida.'
  }, {
    name: 'Leandro C.',
    role: '34 años, Córdoba',
    text: 'Daba clases particulares y siempre sentía que me repetía. El banco de actividades me salvó la vida, literal.'
  }, {
    name: 'Camila S.',
    role: '26 años, Rosario',
    text: 'Lo mejor es el guión paso a paso. Te da una tranquilidad tremenda antes de empezar la clase por Zoom.'
  }, {
    name: 'Florencia M.',
    role: '31 años, Mendoza',
    text: 'Estaba a punto de dejar de dar clases porque me consumía todo el fin de semana planificar. Ahora en 20 minutos tengo la semana armada.'
  }, {
    name: 'Diego T.',
    role: '39 años, La Plata',
    text: 'Los alumnos notan la diferencia. El módulo de adaptación por nivel es oro puro.'
  }];
  return <section className="py-12 md:py-24 bg-brand-50" data-id="element-332">
      <div className="container mx-auto px-4" data-id="element-333">
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16" data-id="element-334">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white border-2 border-accent-200 text-accent-600 font-bold mb-3 md:mb-4 text-xs md:text-sm shadow-sm" data-id="element-335">
            <span className="font-extrabold text-base md:text-lg leading-none" data-id="element-336">
              후기
            </span>
            <span data-id="element-337">· Testimonios verificados</span>
          </div>
          <h2 className="text-2xl md:text-5xl font-extrabold text-brand-950 mb-3 md:mb-6" data-id="element-338">
            Lo que dicen los profesores
          </h2>
          <div className="flex justify-center gap-1 mb-2 md:mb-4" data-id="element-339">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 md:w-6 md:h-6 text-yellow-500 fill-yellow-500" data-id="element-340" />)}
          </div>
          <p className="text-sm md:text-lg text-brand-600 font-medium" data-id="element-341">
            Resultados reales de profesores en toda Argentina y LATAM
          </p>
        </div>

        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 md:gap-6 max-w-7xl mx-auto space-y-4 md:space-y-6" data-id="element-342">
          {testimonials.map((test, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.04
        }} className="break-inside-avoid bg-white p-4 md:p-8 rounded-2xl md:rounded-3xl shadow-soft border border-brand-100 relative" data-id="element-343">
              <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-7 h-7 md:w-10 md:h-10 text-brand-100 rotate-180" data-id="element-344" />
              <div className="flex gap-1 mb-2 md:mb-4" data-id="element-345">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3.5 h-3.5 md:w-4 md:h-4 text-yellow-400 fill-yellow-400" data-id="element-346" />)}
              </div>
              <p className="text-brand-800 text-sm md:text-lg font-medium mb-3 md:mb-6 relative z-10 leading-relaxed" data-id="element-347">
                "{test.text}"
              </p>
              <div className="flex items-center gap-2 md:gap-3" data-id="element-348">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-100 flex items-center justify-center text-brand-700 font-bold text-sm md:text-lg" data-id="element-349">
                  {test.name.charAt(0)}
                </div>
                <div data-id="element-350">
                  <div className="font-bold text-brand-950 text-sm md:text-base" data-id="element-351">
                    {test.name}
                  </div>
                  <div className="text-xs md:text-sm text-brand-500" data-id="element-352">
                    {test.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}